module.exports = "{{#if url}}\r\n    <span class=\"bubbles__link js-bubble-link\">\r\n{{/if}}\r\n    {{name}}\r\n{{#if url}}\r\n    </span>\r\n{{/if}}\r\n<div class=\"svg-icons-wrp svg-icons-wrp_bubble\">\r\n    <div class=\"js-bubble-delete svg-icons-wrp__remove svg-icons-wrp__remove_bubble\">\r\n        <svg class=\"svg-icons svg-icons_remove-bubble\"><use xlink:href=\"#icon-remove\" /> </svg>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/membersBubble/templates/bubble.hbs
// module id = 667
// module chunks = 0